import { ErrorMessage, Field, Form, Formik } from "formik";
import { CaretLeft } from "@phosphor-icons/react";
import { useMemo, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCheckout } from "../../hooks/useCheckout";
import { useGetCart } from "../../hooks/useGetCart";
import OrderSummaryItem from "../../components/OrderSummaryItem";
import { formatAsMoney } from "../../helpers/numbers";
import { HashLoader } from "react-spinners";
// import usePaymentCheckoutOptions from "../../hooks/usePaymentCheckoutOptions";

const Checkout = () => {
  const { cartData } = useGetCart();

  const orderIdRef = useRef<string | null>(null);

  const { checkout, checkingOut, checkoutError, isCheckoutError } =
    useCheckout();

  // const options = usePaymentCheckoutOptions();

  // console.log("payments-options", options);

  const navigate = useNavigate();

  const isError = useMemo(() => {
    return isCheckoutError;
  }, [isCheckoutError]);

  const error = useMemo(() => {
    return checkoutError;
  }, [checkoutError]);

  return (
    <>
      {checkingOut && (
        <div className="fixed top-0 z-[99] left-0 h-screen w-screen flex items-center justify-center bg-black/20 backdrop-blur-sm">
          <HashLoader />
        </div>
      )}
      <div className="p-4 md:p-10 bg-gray-50 flex flex-col gap-5">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="p-2 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300 self-start"
        >
          <CaretLeft weight="bold" />
          <span>Back</span>
        </button>
        <div className="grid grid-cols-1 lg:grid-cols-3 items-start gap-y-5 lg:gap-x-5 max-w-7xl mx-auto">
          <div className="flex flex-col gap-5 col-span-2 bg-white drop-shadow-sm p-5 rounded-xl order-2 lg:order-1">
            <div className="text-3xl font-medium">Checkout</div>
            <Formik
              initialValues={{
                address: "",
                postalCode: "",
                country: "Nigeria",
                city: "",
                state: "",
              }}
              onSubmit={(values) => {
                checkout(
                  {
                    cart_item_ids:
                      cartData?.data?.items?.map((item) => item.id) || [],
                    shipping_address: values.address,
                    shipping_city: values.city,
                    shipping_state: values.state,
                    shipping_country: values.country,
                    shipping_zip_code: values.postalCode,
                    notes: "",
                  },
                  {
                    onSuccess: (checkoutRes) => {
                      if (checkoutRes?.data?.session_id) {
                        const newOrderId = checkoutRes.data.session_id;

                        orderIdRef.current = newOrderId;

                        navigate(
                          `/marketplace/checkout/${newOrderId}/select-payment`
                        );
                      }
                    },
                  }
                );
              }}
            >
              {() => {
                return (
                  <Form className="w-full gap-5 grid-cols-2 grid">
                    <div className="flex flex-col gap-2 col-span-2 w-full">
                      <label
                        htmlFor="address"
                        className="text-sm font-bold text-gray-700"
                      >
                        Shipping address
                      </label>
                      <Field
                        type="address"
                        id="address"
                        name="address"
                        placeholder="Enter your address"
                        className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="flex flex-col gap-2 w-full col-span-2 md:col-span-1">
                      <label
                        htmlFor="address"
                        className="text-sm font-bold text-gray-700"
                      >
                        State
                      </label>
                      <Field
                        type="address"
                        id="state"
                        name="state"
                        placeholder="State"
                        className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                      />
                      <ErrorMessage
                        name="state"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="flex flex-col gap-2 w-full col-span-2 md:col-span-1">
                      <label
                        htmlFor="city"
                        className="text-sm font-bold text-gray-700"
                      >
                        City
                      </label>
                      <Field
                        type="address"
                        id="city"
                        name="city"
                        placeholder="City"
                        className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                      />
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="flex flex-col gap-2 w-full col-span-2 md:col-span-1">
                      <label
                        htmlFor="country"
                        className="text-sm font-bold text-gray-700"
                      >
                        Country
                      </label>
                      <Field
                        as="select"
                        type="text"
                        id="country"
                        name="country"
                        placeholder="country"
                        className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                      >
                        <option disabled value="">
                          Select Country
                        </option>
                        <option value="Afghanistan">Afghanistan</option>
                        <option value="Åland Islands">Åland Islands</option>
                        <option value="Albania">Albania</option>
                        <option value="Algeria">Algeria</option>
                        <option value="American Samoa">American Samoa</option>
                        <option value="Andorra">Andorra</option>
                        <option value="Angola">Angola</option>
                        <option value="Anguilla">Anguilla</option>
                        <option value="Antarctica">Antarctica</option>
                        <option value="Antigua and Barbuda">
                          Antigua and Barbuda
                        </option>
                        <option value="Argentina">Argentina</option>
                        <option value="Armenia">Armenia</option>
                        <option value="Aruba">Aruba</option>
                        <option value="Australia">Australia</option>
                        <option value="Austria">Austria</option>
                        <option value="Azerbaijan">Azerbaijan</option>
                        <option value="Bahamas">Bahamas</option>
                        <option value="Bahrain">Bahrain</option>
                        <option value="Bangladesh">Bangladesh</option>
                        <option value="Barbados">Barbados</option>
                        <option value="Belarus">Belarus</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Belize">Belize</option>
                        <option value="Benin">Benin</option>
                        <option value="Bermuda">Bermuda</option>
                        <option value="Bhutan">Bhutan</option>
                        <option value="Bolivia">Bolivia</option>
                        <option value="Bosnia and Herzegovina">
                          Bosnia and Herzegovina
                        </option>
                        <option value="Botswana">Botswana</option>
                        <option value="Bouvet Island">Bouvet Island</option>
                        <option value="Brazil">Brazil</option>
                        <option value="British Indian Ocean Territory">
                          British Indian Ocean Territory
                        </option>
                        <option value="Brunei Darussalam">
                          Brunei Darussalam
                        </option>
                        <option value="Bulgaria">Bulgaria</option>
                        <option value="Burkina Faso">Burkina Faso</option>
                        <option value="Burundi">Burundi</option>
                        <option value="Cambodia">Cambodia</option>
                        <option value="Cameroon">Cameroon</option>
                        <option value="Canada">Canada</option>
                        <option value="Cape Verde">Cape Verde</option>
                        <option value="Cayman Islands">Cayman Islands</option>
                        <option value="Central African Republic">
                          Central African Republic
                        </option>
                        <option value="Chad">Chad</option>
                        <option value="Chile">Chile</option>
                        <option value="China">China</option>
                        <option value="Christmas Island">
                          Christmas Island
                        </option>
                        <option value="Cocos (Keeling) Islands">
                          Cocos (Keeling) Islands
                        </option>
                        <option value="Colombia">Colombia</option>
                        <option value="Comoros">Comoros</option>
                        <option value="Congo">Congo</option>
                        <option value="Congo, The Democratic Republic of The">
                          Congo, The Democratic Republic of The
                        </option>
                        <option value="Cook Islands">Cook Islands</option>
                        <option value="Costa Rica">Costa Rica</option>
                        <option value="Cote D'ivoire">Cote D'ivoire</option>
                        <option value="Croatia">Croatia</option>
                        <option value="Cuba">Cuba</option>
                        <option value="Cyprus">Cyprus</option>
                        <option value="Czech Republic">Czech Republic</option>
                        <option value="Denmark">Denmark</option>
                        <option value="Djibouti">Djibouti</option>
                        <option value="Dominica">Dominica</option>
                        <option value="Dominican Republic">
                          Dominican Republic
                        </option>
                        <option value="Ecuador">Ecuador</option>
                        <option value="Egypt">Egypt</option>
                        <option value="El Salvador">El Salvador</option>
                        <option value="Equatorial Guinea">
                          Equatorial Guinea
                        </option>
                        <option value="Eritrea">Eritrea</option>
                        <option value="Estonia">Estonia</option>
                        <option value="Ethiopia">Ethiopia</option>
                        <option value="Falkland Islands (Malvinas)">
                          Falkland Islands (Malvinas)
                        </option>
                        <option value="Faroe Islands">Faroe Islands</option>
                        <option value="Fiji">Fiji</option>
                        <option value="Finland">Finland</option>
                        <option value="France">France</option>
                        <option value="French Guiana">French Guiana</option>
                        <option value="French Polynesia">
                          French Polynesia
                        </option>
                        <option value="French Southern Territories">
                          French Southern Territories
                        </option>
                        <option value="Gabon">Gabon</option>
                        <option value="Gambia">Gambia</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Germany">Germany</option>
                        <option value="Ghana">Ghana</option>
                        <option value="Gibraltar">Gibraltar</option>
                        <option value="Greece">Greece</option>
                        <option value="Greenland">Greenland</option>
                        <option value="Grenada">Grenada</option>
                        <option value="Guadeloupe">Guadeloupe</option>
                        <option value="Guam">Guam</option>
                        <option value="Guatemala">Guatemala</option>
                        <option value="Guernsey">Guernsey</option>
                        <option value="Guinea">Guinea</option>
                        <option value="Guinea-bissau">Guinea-bissau</option>
                        <option value="Guyana">Guyana</option>
                        <option value="Haiti">Haiti</option>
                        <option value="Heard Island and Mcdonald Islands">
                          Heard Island and Mcdonald Islands
                        </option>
                        <option value="Holy See (Vatican City State)">
                          Holy See (Vatican City State)
                        </option>
                        <option value="Honduras">Honduras</option>
                        <option value="Hong Kong">Hong Kong</option>
                        <option value="Hungary">Hungary</option>
                        <option value="Iceland">Iceland</option>
                        <option value="India">India</option>
                        <option value="Indonesia">Indonesia</option>
                        <option value="Iran, Islamic Republic of">
                          Iran, Islamic Republic of
                        </option>
                        <option value="Iraq">Iraq</option>
                        <option value="Ireland">Ireland</option>
                        <option value="Isle of Man">Isle of Man</option>
                        <option value="Israel">Israel</option>
                        <option value="Italy">Italy</option>
                        <option value="Jamaica">Jamaica</option>
                        <option value="Japan">Japan</option>
                        <option value="Jersey">Jersey</option>
                        <option value="Jordan">Jordan</option>
                        <option value="Kazakhstan">Kazakhstan</option>
                        <option value="Kenya">Kenya</option>
                        <option value="Kiribati">Kiribati</option>
                        <option value="Korea, Democratic People's Republic of">
                          Korea, Democratic People's Republic of
                        </option>
                        <option value="Korea, Republic of">
                          Korea, Republic of
                        </option>
                        <option value="Kuwait">Kuwait</option>
                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                        <option value="Lao People's Democratic Republic">
                          Lao People's Democratic Republic
                        </option>
                        <option value="Latvia">Latvia</option>
                        <option value="Lebanon">Lebanon</option>
                        <option value="Lesotho">Lesotho</option>
                        <option value="Liberia">Liberia</option>
                        <option value="Libyan Arab Jamahiriya">
                          Libyan Arab Jamahiriya
                        </option>
                        <option value="Liechtenstein">Liechtenstein</option>
                        <option value="Lithuania">Lithuania</option>
                        <option value="Luxembourg">Luxembourg</option>
                        <option value="Macao">Macao</option>
                        <option value="Macedonia, The Former Yugoslav Republic of">
                          Macedonia, The Former Yugoslav Republic of
                        </option>
                        <option value="Madagascar">Madagascar</option>
                        <option value="Malawi">Malawi</option>
                        <option value="Malaysia">Malaysia</option>
                        <option value="Maldives">Maldives</option>
                        <option value="Mali">Mali</option>
                        <option value="Malta">Malta</option>
                        <option value="Marshall Islands">
                          Marshall Islands
                        </option>
                        <option value="Martinique">Martinique</option>
                        <option value="Mauritania">Mauritania</option>
                        <option value="Mauritius">Mauritius</option>
                        <option value="Mayotte">Mayotte</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Micronesia, Federated States of">
                          Micronesia, Federated States of
                        </option>
                        <option value="Moldova, Republic of">
                          Moldova, Republic of
                        </option>
                        <option value="Monaco">Monaco</option>
                        <option value="Mongolia">Mongolia</option>
                        <option value="Montenegro">Montenegro</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Morocco">Morocco</option>
                        <option value="Mozambique">Mozambique</option>
                        <option value="Myanmar">Myanmar</option>
                        <option value="Namibia">Namibia</option>
                        <option value="Nauru">Nauru</option>
                        <option value="Nepal">Nepal</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="Netherlands Antilles">
                          Netherlands Antilles
                        </option>
                        <option value="New Caledonia">New Caledonia</option>
                        <option value="New Zealand">New Zealand</option>
                        <option value="Nicaragua">Nicaragua</option>
                        <option value="Niger">Niger</option>
                        <option value="Nigeria">Nigeria</option>
                        <option value="Niue">Niue</option>
                        <option value="Norfolk Island">Norfolk Island</option>
                        <option value="Northern Mariana Islands">
                          Northern Mariana Islands
                        </option>
                        <option value="Norway">Norway</option>
                        <option value="Oman">Oman</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Palau">Palau</option>
                        <option value="Palestinian Territory, Occupied">
                          Palestinian Territory, Occupied
                        </option>
                        <option value="Panama">Panama</option>
                        <option value="Papua New Guinea">
                          Papua New Guinea
                        </option>
                        <option value="Paraguay">Paraguay</option>
                        <option value="Peru">Peru</option>
                        <option value="Philippines">Philippines</option>
                        <option value="Pitcairn">Pitcairn</option>
                        <option value="Poland">Poland</option>
                        <option value="Portugal">Portugal</option>
                        <option value="Puerto Rico">Puerto Rico</option>
                        <option value="Qatar">Qatar</option>
                        <option value="Reunion">Reunion</option>
                        <option value="Romania">Romania</option>
                        <option value="Russian Federation">
                          Russian Federation
                        </option>
                        <option value="Rwanda">Rwanda</option>
                        <option value="Saint Helena">Saint Helena</option>
                        <option value="Saint Kitts and Nevis">
                          Saint Kitts and Nevis
                        </option>
                        <option value="Saint Lucia">Saint Lucia</option>
                        <option value="Saint Pierre and Miquelon">
                          Saint Pierre and Miquelon
                        </option>
                        <option value="Saint Vincent and The Grenadines">
                          Saint Vincent and The Grenadines
                        </option>
                        <option value="Samoa">Samoa</option>
                        <option value="San Marino">San Marino</option>
                        <option value="Sao Tome and Principe">
                          Sao Tome and Principe
                        </option>
                        <option value="Saudi Arabia">Saudi Arabia</option>
                        <option value="Senegal">Senegal</option>
                        <option value="Serbia">Serbia</option>
                        <option value="Seychelles">Seychelles</option>
                        <option value="Sierra Leone">Sierra Leone</option>
                        <option value="Singapore">Singapore</option>
                        <option value="Slovakia">Slovakia</option>
                        <option value="Slovenia">Slovenia</option>
                        <option value="Solomon Islands">Solomon Islands</option>
                        <option value="Somalia">Somalia</option>
                        <option value="South Africa">South Africa</option>
                        <option value="South Georgia and The South Sandwich Islands">
                          South Georgia and The South Sandwich Islands
                        </option>
                        <option value="Spain">Spain</option>
                        <option value="Sri Lanka">Sri Lanka</option>
                        <option value="Sudan">Sudan</option>
                        <option value="Suriname">Suriname</option>
                        <option value="Svalbard and Jan Mayen">
                          Svalbard and Jan Mayen
                        </option>
                        <option value="Swaziland">Swaziland</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Syrian Arab Republic">
                          Syrian Arab Republic
                        </option>
                        <option value="Taiwan">Taiwan</option>
                        <option value="Tajikistan">Tajikistan</option>
                        <option value="Tanzania, United Republic of">
                          Tanzania, United Republic of
                        </option>
                        <option value="Thailand">Thailand</option>
                        <option value="Timor-leste">Timor-leste</option>
                        <option value="Togo">Togo</option>
                        <option value="Tokelau">Tokelau</option>
                        <option value="Tonga">Tonga</option>
                        <option value="Trinidad and Tobago">
                          Trinidad and Tobago
                        </option>
                        <option value="Tunisia">Tunisia</option>
                        <option value="Turkey">Turkey</option>
                        <option value="Turkmenistan">Turkmenistan</option>
                        <option value="Turks and Caicos Islands">
                          Turks and Caicos Islands
                        </option>
                        <option value="Tuvalu">Tuvalu</option>
                        <option value="Uganda">Uganda</option>
                        <option value="Ukraine">Ukraine</option>
                        <option value="United Arab Emirates">
                          United Arab Emirates
                        </option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="United States">United States</option>
                        <option value="United States Minor Outlying Islands">
                          United States Minor Outlying Islands
                        </option>
                        <option value="Uruguay">Uruguay</option>
                        <option value="Uzbekistan">Uzbekistan</option>
                        <option value="Vanuatu">Vanuatu</option>
                        <option value="Venezuela">Venezuela</option>
                        <option value="Viet Nam">Viet Nam</option>
                        <option value="Virgin Islands, British">
                          Virgin Islands, British
                        </option>
                        <option value="Virgin Islands, U.S.">
                          Virgin Islands, U.S.
                        </option>
                        <option value="Wallis and Futuna">
                          Wallis and Futuna
                        </option>
                        <option value="Western Sahara">Western Sahara</option>
                        <option value="Yemen">Yemen</option>
                        <option value="Zambia">Zambia</option>
                        <option value="Zimbabwe">Zimbabwe</option>
                      </Field>
                      <ErrorMessage
                        name="country"
                        component="div"
                        className="text-red-500"
                      />
                    </div>

                    <div className="flex flex-col gap-2 w-full col-span-2 md:col-span-1">
                      <label
                        htmlFor="postalCode"
                        className="text-sm font-bold text-gray-700"
                      >
                        Postal Code
                      </label>
                      <Field
                        type="text"
                        id="postalCode"
                        name="postalCode"
                        placeholder="Postal code"
                        className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                      />
                      <ErrorMessage
                        name="postalCode"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="col-span-2 flex flex-col gap-4">
                      {/* <div className="font-medium text-lg">
                        Select Payment Method
                      </div>
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                        {paymentMethods.map((method) => {
                          return (
                            <button
                              type="button"
                              onClick={() =>
                                setSelectedPaymentMethod(method.code)
                              }
                              key={method.code}
                              className={`hover:bg-gray-50 border rounded-md border-gray-200 p-5 text-left flex items-start gap-2 ${
                                selectedPaymentMethod === method.code &&
                                "text-visaro-orange bg-gray-50"
                              }`}
                            >
                              <div className="text-visaro-orange rounded-full p-2 bg-visaro-orange/10">
                                <method.icon weight="bold" size={20} />
                              </div>
                              <div className="flex flex-col items-start flex-1">
                                <div className="font-medium">{method.name}</div>
                                <div className="text-gray-500">
                                  {method.description}
                                </div>
                              </div>
                              {selectedPaymentMethod === method.code ? (
                                <div className="bg-visaro-orange p-1 rounded-full">
                                  <Check
                                    className="text-white"
                                    weight="bold"
                                    size={16}
                                  />
                                </div>
                              ) : (
                                <div className="p-1 rounded-full">
                                  <Check
                                    className="text-white invisible"
                                    weight="bold"
                                    size={16}
                                  />
                                </div>
                              )}
                            </button>
                          );
                        })}
                      </div>
                      <div className="flex items-center gap-1 text-center text-visaro-orange text-sm">
                        <ShieldCheck weight="bold" size={18} />
                        <div>Secure Payment</div>
                      </div> */}
                      <button
                        disabled={checkingOut}
                        type="submit"
                        className="p-4 px-5 w-full text-center border-visaro-gray-700 border rounded-lg font-bold bg-deepBlue text-white text-sm"
                      >
                        {checkingOut ? "Loading" : "Proceed"}
                      </button>
                      {isError && (
                        <div className="text-red-500 text-left flex">
                          {error?.message}
                        </div>
                      )}
                      <div className="text-left">
                        By clicking “Proceed”. you agree to our{" "}
                        <Link to="/legal" className="text-visaro-orange">
                          Return policy
                        </Link>{" "}
                        &{" "}
                        <Link to="/legal" className="text-visaro-orange">
                          Terms and Conditions
                        </Link>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
          <div className="flex flex-col gap-5 col-span-1 bg-white drop-shadow-sm p-5 rounded-xl order-1">
            <div className="font-medium">Order Summary</div>
            <div className="flex flex-col w-full flex-1 gap-4">
              {cartData?.data?.items?.map((item) => {
                return <OrderSummaryItem item={item} key={item.id} />;
              })}
            </div>
            <div className="flex flex-col gap-2 border-t pt-2">
              <div className="flex items-center justify-between font-medium text-xl">
                <div>Total</div>
                <div>₦{formatAsMoney(cartData?.data?.total_amount || 0)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
